// src/services/vendas/NotaFiscalService.js
import { deleteData, fetchData, postData } from '../Api';

const montarQueryCancelamento = (notaId, motivoCancelamento) => {
    const query = new URLSearchParams({
        notaId: String(notaId),
        motivoCancelamento,
    });

    return query.toString();
};

export const cancelarNotaFiscal = async ({ notaId, modeloDoc, motivoCancelamento }) => {
    const query = montarQueryCancelamento(notaId, motivoCancelamento);
    const modeloNormalizado = String(modeloDoc || '').toUpperCase();

    if (modeloNormalizado === 'NFSE') {
        const resultado = await postData(`/NFSe/Cancelar?${query}`);

        if (resultado?.cancelada === false) {
            throw new Error(resultado.erros || 'A NFS-e não pôde ser cancelada.');
        }

        return resultado;
    }

    return postData(`/DFe/CancelarNFCe?${query}`);
};

export const excluirRecibo = async ({ notaId, justificativa }) =>
    deleteData('/Nota', { notaId }, { justificativa });

export const buscarRecebimentosVinculadosNota = async (notaId) =>
    fetchData(`/Nota/${notaId}/RecebimentosVinculados`);
